// apps/admin/src/lib/format.js
//
// Small shared display formatters for the admin screens. `formatBytes` in
// particular was duplicated verbatim across dashboard.js and database.js (and
// had already begun to drift — Math.round vs toFixed(0), same rendered string);
// hoisting it here keeps ONE implementation both screens import.

export function formatBytes(bytes) {
  if (!Number.isFinite(bytes) || bytes <= 0) return '0 B';
  const units = ['B', 'KB', 'MB', 'GB', 'TB'];
  const i = Math.min(Math.floor(Math.log(bytes) / Math.log(1024)), units.length - 1);
  const value = bytes / (1024 ** i);
  return `${value >= 10 || i === 0 ? value.toFixed(0) : value.toFixed(1)} ${units[i]}`;
}
